import { render, staticRenderFns } from "./TenantModal.vue?vue&type=template&id=48db5b2a&scoped=true"
import script from "./TenantModal.vue?vue&type=script&lang=js"
export * from "./TenantModal.vue?vue&type=script&lang=js"
import style0 from "./TenantModal.vue?vue&type=style&index=0&id=48db5b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48db5b2a",
  null
  
)

export default component.exports